// import React, { useState, useEffect } from 'react'
// import { Container, Card, Row, Col, Accordion } from 'react-bootstrap';
// import 'bootstrap/dist/css/bootstrap.css';
// import '../../node_modules/font-awesome/css/font-awesome.min.css'
// import BoxItemDropDown from '../components/BoxItemDropDown'
// import '../css/BoxItem.css';
// import DND from '../containers/comps/DNDContainer'
// import axiosConfig from '../config/axiosConfig'


// import HeadingBox from '../components/HeadingBox'

// const headers = {
//     'Content-Type': 'application/json',
//     'APIkey': 'C5BFF7F0-B4DF-475E-A331-F737424F013C',
// }

// function Child({ items }) {
//     //console.log("Items", items)
//     return (
//         items.vrnMapping.map((el, index) => {
//             return (
//                 //  {console.log("el = ", el)}
//                 <div className="box-item btn btn-default w-100">
//                     <BoxItemDropDown index={index} name={el.vrn} accordionSubItems={el.paNs} deleteDialog='yes' ></BoxItemDropDown>
//                 </div>
//             )
//         })
//     );
// }

// function ManageShellCard(props) {

//     const [UserData, setUserData] = useState([]);
//     const [selectedBranchID, setSelectedBranchID] = useState(props.data.selectedBranchId)
//     const [selectedBranchNumber, setSelectedBranchNumber] = useState(props.data.selectedBranchNumber)
//     const [refreshCardMappingcounter, setRefreshCardMappingCounter] = useState(0)
//     let cartCounter = 0;
//      function getCardMapping() {
        
//             axiosConfig.post('Portal/GetCardMapping', {
//                 "UserBranchID": props.data.selectedBranchId
//             })
//                 .then((res) => {
//                     setUserData(res.data);
//                 })
//                 .catch(console.error)
//                 .finally(() => {
//                 });
//     }

//     useEffect(() => {
//         getCardMapping();
//     }, [refreshCardMappingcounter],props.data.selectedBranchId);

//     function refreshCardMapping(data){
//         setRefreshCardMappingCounter(prevCount => prevCount + 1)
//     }

//     return (
//         <>
//             <Container>
//             <HeadingBox title="Drag & drop a Shell Card & Vehicle to create a Combination"></HeadingBox>

//                 <Row>
//                     <DND TotalFee={props.data.TotalFee} IncrementalFee={props.data.IncrementalFee} refreshCardMapping={refreshCardMapping}> </DND>
//                 </Row>
//                 <Row className="m-0">
//                     <Col>
//                         <Accordion>
//                             <Card className="card p-3 text-center" style={{ width: '100%', margin: 'auto', boxShadow: '0px 0px 10px 2px rgba(64, 64, 64, 0.3)' }}>
//                                 <Card.Title >
//                                     <p className="pull-left">Your Mapped Shell Cards & Vehicles </p>
//                                     </Card.Title>
                                
//                                 <Card.Body>
//                                     {UserData.vrnMapping && <Child items={UserData} />}
//                                 </Card.Body>
//                             </Card>
//                         </Accordion>
//                     </Col>
//                 </Row>
//             </Container>
//             {/* <CustomFooter /> */}
//         </>

//     );
// }

// export default ManageShellCard;


import React, { useState, useEffect } from 'react';
import { Container, Card, Row, Col, Accordion, Form , Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import '../../node_modules/font-awesome/css/font-awesome.min.css';
import BoxItemDropDown from '../components/BoxItemDropDown';
import '../css/BoxItem.css';
import DND from '../containers/comps/DNDContainer';
import axiosConfig from '../config/axiosConfig';
import HeadingBox from '../components/HeadingBox';
import { useHistory } from 'react-router-dom';


const headers = {
  'Content-Type': 'application/json',
  APIkey: 'C5BFF7F0-B4DF-475E-A331-F737424F013C',
};

function Child({ items }) {
  return (
    items.vrnMapping.map((el, index) => (
      <div className="box-item btn btn-default w-100" key={index}>
        
        <BoxItemDropDown index={index} name={el.vrn} accordionSubItems={el.paNs} deleteDialog="yes" />
      </div>
    ))
  );
}

function ManageShellCard(props) {
  const [UserData, setUserData] = useState({ vrnMapping: [] });
  const [selectedBranchID, setSelectedBranchID] = useState(props.data.selectedBranchId);
  const [selectedBranchNumber, setSelectedBranchNumber] = useState(props.data.selectedBranchNumber);
  const [refreshCardMappingcounter, setRefreshCardMappingCounter] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const history = useHistory(); // Create history object

  function getCardMapping() {
    axiosConfig.post('Portal/GetCardMapping', {
      UserBranchID: props.data.selectedBranchId,
    })
      .then((res) => {
        setUserData(res.data);
      })
      .catch(console.error)
      .finally(() => {
      });
  }

  useEffect(() => {
    getCardMapping();
  }, [refreshCardMappingcounter, props.data.selectedBranchId]);

  function refreshCardMapping() {
    setRefreshCardMappingCounter((prevCount) => prevCount + 1);
  }

  function handleSearchChange(event) {
    setSearchQuery(event.target.value);
  }

  function filterItems() {
    // return UserData.vrnMapping ? UserData.vrnMapping.filter((el) => el.vrn.includes(searchQuery)) : [];
  //   return UserData.vrnMapping ? UserData.vrnMapping.filter((el) => el.vrn.toLowerCase().includes(searchQuery.toLowerCase())
  //   )
  // : [];
  // }
  return UserData.vrnMapping
  ? UserData.vrnMapping.filter((el) => {
      const vrnMatch = el.vrn.toLowerCase().includes(searchQuery.toLowerCase());
      const paNsMatch = el.paNs.some((paN) => paN.includes(searchQuery.toLowerCase()));
      return vrnMatch || paNsMatch;
    })
  : [];
  }

  function handleBackButtonClick() {
    debugger
    // window.find();
    history.push('/Manage'); // Replace '/other-page' with the path of the desired page
  }


  return (
    <>
      <Container>
      <Row className="align-items-center">
        
        

        
  <Button  variant="warning myBtn" onClick={handleBackButtonClick} >
    Back
  </Button>



        </Row>

        <h4 className="card-title"> <h4>Map Shell Card and Vehicles</h4></h4>

        {/* {<header className="col">Map Shell Card and Vehicles</header> */}
       {/* <HeadingBox title="Drag & drop a Shell Card & Vehicle to create a Combination" /> */}
        <HeadingBox title="Create Card-Vehicle combinations to track vehicle performance" />
        <Row>
          <DND TotalFee={props.data.TotalFee} IncrementalFee={props.data.IncrementalFee} refreshCardMapping={refreshCardMapping} />
        </Row>
        <Row className="m-2">
          <Col>
            <Accordion>
              <Card className="card p-3 text-center" style={{ width: '100%', margin: 'auto', boxShadow: '0px 0px 10px 2px rgba(64, 64, 64, 0.3)' }}>
                <Card.Title>
                  <div className="d-flex align-items-center justify-content-between p-3">
                    <p style={{paddingLeft:'10px'}}>Your Mapped Shell Cards & Vehicles         
                    </p>
                    <div>
                    <input type="text" placeholder="Search" value={searchQuery} onChange={handleSearchChange} style={{width:'200px',fontWeight:'lighter',fontSize:'18px'}} />
                    </div>
                    {/* <Form.Control type="text" placeholder="Search" value={searchQuery} onChange={handleSearchChange} /> */}
                    
                   </div>
                </Card.Title>
                <Card.Body>
                  {filterItems().length > 0 ? (
                    <Child items={{ vrnMapping: filterItems() }} />
                    
                  ) : (
                    <p>No matching items found.</p>
                  )}
                </Card.Body>
              </Card>
            </Accordion>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ManageShellCard;


